import React, { useState ,useEffect } from "react";

const UserModal = ({ onClose, onSubmit }) => {
    const [Departments, setDepartments] = useState([]);
    const [Heads, setHeads] = useState([]);
      const [error, setError] = useState("");
      const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    department_id:"",
    role: "",
    password: "",
  });
  const [roles, setRoles] = useState([]);
  
  const Auth = localStorage.getItem("authToken");

 useEffect(() => {
    fetchRoles();
  }, []);

  //fetch the roles Data

const fetchRoles = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/departments/list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch data");

      const result = await response.json();

      
      setDepartments(result);

      
      const flattened = result.flatMap((dept) =>
        (dept.roles || []).map((role) => ({
          id: role.id,
          department: dept.name,
          department_id: dept.id,
          role_name: role.name,
          reporting_id: role.reporting_id,
        }))
      );

      setRoles(flattened);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching roles:", err);
      setError(err.message);
      setLoading(false);
    }
  };

const handleDepartmentChange = (e) => {
  const deptId = e.target.value;
  setFormData((prev) => ({ ...prev, department_id: deptId, reporting_id: "" }));

  const selectedDept = Departments.find((d) => d.id == deptId);

  if (selectedDept) {
    let rolesList = selectedDept.roles || [];

    
    const hasAdmin = rolesList.some(
      (role) => role.name.toLowerCase() === "admin"
    );

    
    if (!hasAdmin) {
      rolesList = [ ...rolesList];
    }

    setHeads(rolesList);
  } else {
    setHeads([]);
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    // submit to our Main User Details Page
    if (onSubmit) {
      onSubmit(formData); 
    }
  };
    const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6">
        
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Add New User</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✕
          </button>
        </div>

        
        <div className="space-y-4">
          <div>
            <label className="block font-semibold text-gray-700">Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter full name"
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>

          <div>
            <label className="block font-semibold text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>

          
          <div className="mb-2">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Department Name *
            </label>
            <select
              name="department_id"
              value={formData.department_id}
              onChange={handleDepartmentChange}
              className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
              required
            >
              <option value="">Select Department</option>
              {Departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block font-semibold text-gray-700">Designation</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleInputChange}
              className="shadow border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
              required
            >
              <option value="">Select Designation</option>
              {Heads.map((head) => (
                <option key={head.id} value={head.id}>
                  {head.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block font-semibold text-gray-700">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter password"
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>
        </div>

       
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
